<script setup>
import axios from '@/../../EshJSLib/services/axios'
import { reactive, ref, onMounted } from "vue";
import { Modal } from "flowbite-vue";

const title = 'Funzionalita'
const isShowModal = reactive({
  permessi: false
});


const dataPermessi = ref([])
const recordPermesso = ref([])

const roleList = ref([])


onMounted(async () => {

  refreshData();

})

function refreshData() {

  axios.get(`/api/security/permissionList`).then(response => dataPermessi.value = response.data)
    .catch(error => console.log(error));
}

function showAddPermessi() {
  recordPermesso.value = {};
  isShowModal.permessi = true;
}



function addPermessi() {

  const ruoli = axios.post(`/api/security/addPermesso`, { data: recordPermesso.value });
  isShowModal.permessi = false;
  refreshData();
}


</script>



<template>
  <h1 class="center">{{ title }}</h1>
  <Modal v-show="isShowModal.permessi" @close="isShowModal.permessi = false;">
    <template #header>
      Aggiungi nuovo {{ title }}
    </template>
    <template #body>
      <div>
        <p> Descrizione </p>
        <input v-model="recordPermesso.permesso" type="text" />
      </div>
      <div class="actionTable">
        <button class="button" @click="isShowModal.permessi = false;">Annulla </button>
        <button class="button" @click="addPermessi">Aggiungi {{ title }}</button>
      </div>
      <table></table>
    </template>
  </Modal>


  <div class="actionTable">
    <button class="button">Cancella {{ title }}</button>
    <button class="button" @click="showAddPermessi">Aggiungi {{ title }}</button>
  </div>


  <table>

    <thead>
      <tr>
        <th></th>
        <th data-type="numeric">ID</th>
        <th data-type="text-short">Descrizione</th>


      </tr>
    </thead>
    <tbody>
      <tr v-for="(value, i) in dataPermessi" :key="i">

        <td><input type="checkbox"></td>
        <td>{{ value.id }}</td>
        <td>{{ value.name }}</td>

      </tr>
    </tbody>
  </table>

</template>


<style>
* {
  box-sizing: border-box;
}

.actionTable {
  display: flex;
  justify-content: flex-end;
  margin: 10px;
}

.button {
  background-color: #04AA6D;
  /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 10px;

}

.center {
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  border: 3px solid green;
  margin-top: 10px;
  margin-bottom: 10px;
}

html,
body {
  padding: 0;
  margin: 0;
}

body {
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", "Helvetica", "Arial", sans-serif;
}

table {
  display: grid;
  border-collapse: collapse;
  min-width: 100%;
  grid-template-columns:
    minmax(150px, 1fr) minmax(150px, 1.67fr) minmax(150px, 1.67fr);
}

thead,
tbody,
tr {
  display: contents;
}

th,
td {
  padding: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

th {
  position: sticky;
  top: 0;
  background: #1A576E;
  text-align: left;
  font-weight: normal;
  font-size: 1.1rem;
  color: white;
}

th:last-child {
  border: 0;
}

td {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #808080;
}

tr:nth-child(even) td {
  background: #f8f6ff;
}
</style>